module.exports = __webpack_public_path__ + "img/ETERNO_S.49a47771.png";